import { writable } from 'svelte/store';
import en from './locales/en.js';
import nl from './locales/nl.js';

const translations = { en, nl };
const fallbackLanguage = 'en';
const currentLanguage = writable(localStorage.getItem('lang') || 'en');

currentLanguage.subscribe(value => {
    localStorage.setItem('lang', value);
});

export default function t(key, ...placeholders) {
    let lang;
    currentLanguage.subscribe(value => lang = value)();
    let translation = translations[lang]?.[key] || translations[fallbackLanguage]?.[key] || key;

    placeholders.forEach((value, index) => {
        translation = translation.replace(new RegExp(`\\{${index + 1}\\}`, 'g'), value);
    });

    return translation;
}
